import { Button } from "antd"
import { useQuickBooksDisconnectMutation } from "./quickBooksQueries"

const QuickBooksDisconnectButton = () => {
    const quickBooksDisconnectMutation = useQuickBooksDisconnectMutation(() => {
        window.location.reload();
    })
    return <>
        <Button 
            type='default' 
            title={'Disconnect from QuickBooks'}
            style={{cursor: 'pointer'}}
            danger
            onClick={() => quickBooksDisconnectMutation.mutate()}
        >
            Disconnect from QuickBooks
        </Button>
    </>
}

export default QuickBooksDisconnectButton
